module.exports = __webpack_public_path__ + "img/feder.3297859d.png";